export default {
    ca: {
        title: 'Crear usuaris derivats per treballar amb el mapa:',
        message: 'Indica el nombre de còpies del mapa a crear',
        messageError: 'No s\'han pogut crear les còpies demanades',
        crear_usuaris: 'Crear còpies',
        numUsuarisPlaceholder: 'Nombre de còpies',
        nota: 'Nota: els usuaris derivats depenen en realitat de l\'usuari que ha creat les diferents còpies d\'un mapa',
        messageDerivats: 'Veure els mapes derivats a la meva galeria personal',
        notaEsperar:'Quan aquesta finestra es tanqui els mapes ja estaran creats i es refrescarà automàticament la galeria privada'
    },
    es: {
        title: 'Crear usuarios derivados para trabajar con el mapa:',
        message: 'Indica el número de copias del mapa a crear',
        messageError: 'No se han podido crear las copias pedidas',
        crear_usuaris: 'Crear copias',
        numUsuarisPlaceholder: 'Número de copias',
        nota:'Nota: los usuarios derivados dependen en realidad del usuario que ha creado las diferentes copias de un mapa',
        messageDerivats: 'Ver los mapas derivados en mi galería personal',
        notaEsperar:'Cuando esta ventana se cierre los mapas ya estarán creados y se refrescará automáticamente la galería privada'
    },
    en: {
        title: 'Create derived users to work with the map:',
        message: 'Specify the number of copies of the map to create',
        messageError: 'Could not create requested copies',
        crear_usuaris: 'Create copies',
        numUsuarisPlaceholder: 'Number of copies',
        nota:'Note: Derived users actually depend on the user who created the different copies of a map.',
        messageDerivats: 'View the derived maps in my personal gallery',
        notaEsperar:'When this window closes the maps will be created and the private gallery will be refreshed automatically'
    },
};



// WEBPACK FOOTER //
// ./src/perfil/components/crearusuaris-modal/crearusuaris-modal-translations.js